import { render, staticRenderFns } from "./SystemAccessDenied.vue?vue&type=template&id=224f867a&"
import script from "./SystemAccessDenied.vue?vue&type=script&lang=js&"
export * from "./SystemAccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224f867a')) {
      api.createRecord('224f867a', component.options)
    } else {
      api.reload('224f867a', component.options)
    }
    module.hot.accept("./SystemAccessDenied.vue?vue&type=template&id=224f867a&", function () {
      api.rerender('224f867a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemAccessDenied.vue"
export default component.exports